import { INVENTORY_CATEGORY_OPTIONS } from "../constants/inventoryCategories";

/**
 * Categories offered by the inventory chat: the ones already used by the
 * terreiro's items (what the Categorias tab groups by), or the built-in list
 * when there are none yet.
 */
export const resolveInventoryChatCategories = (
  items: ReadonlyArray<{ category?: string | null }>,
): string[] => {
  const categories = [
    ...new Set(
      items
        .map((item) => item.category?.trim())
        .filter((category): category is string => Boolean(category)),
    ),
  ].sort((left, right) => left.localeCompare(right, "pt-BR"));

  return categories.length > 0 ? categories : [...INVENTORY_CATEGORY_OPTIONS];
};
